// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarSectionHeader_root__ftzV6","icon":"SidebarSectionHeader_icon__1LM8J"};